module.exports = __webpack_public_path__ + "img/filter.f9459141.svg";